import { useEffect, useState } from 'react';
import client from '../api/client';
import { useAuth } from '../context/AuthContext';

const ROLES = ['ADMIN','SUPPORT','FINANCE','DEVELOPER','SALES','AREA_MANAGER','REGIONAL_MANAGER'];
const rc = { SUPER_ADMIN:'#d97706', ADMIN:'#e05c5c', SUPPORT:'#1a5cff', FINANCE:'#059669', DEVELOPER:'#7c3aed', SALES:'#0891b2', AREA_MANAGER:'#7c3aed', REGIONAL_MANAGER:'#db2777' };

export default function Staff() {
  const [staff, setStaff] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ name:'', email:'', phone:'', role:'SUPPORT' });
  const [msg, setMsg] = useState('');
  const [modal, setModal] = useState(null);
  const [otpStep, setOtpStep] = useState('request'); // request | confirm
  const [otp, setOtp] = useState('');
  const [editForm, setEditForm] = useState({});
  const [otpLoading, setOtpLoading] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const { role } = useAuth();

  const inp = (extra={}) => ({ padding:'10px 14px', background:'#f9f9f9', border:'1px solid #ddd', borderRadius:8, color:'#000', fontSize:14, outline:'none', width:'100%', boxSizing:'border-box', marginBottom:12, ...extra });
  const btn = (c, tc, disabled=false) => ({ padding:'8px 16px', background:disabled?'#f5f5f5':c, color:disabled?'#aaa':tc, border:'none', borderRadius:6, cursor:disabled?'not-allowed':'pointer', fontSize:13, fontWeight:700, opacity:disabled?0.6:1 });

  const load = () => { setLoading(true); client.get('/admin/staff').then(r=>setStaff(r.data||[])).catch(()=>setStaff([])).finally(()=>setLoading(false)); };
  useEffect(()=>{ load(); }, []);

  const create = async () => {
    if (!form.name||!form.email) return setMsg('Name and email required');
    try { await client.post('/admin/staff', form); setMsg('Staff created'); setShowForm(false); setForm({ name:'', email:'', phone:'', role:'SUPPORT' }); load(); }
    catch(e) { setMsg(e.response?.data||'Failed'); }
  };

  const openModal = (type, s) => {
    setModal({ type, staff: s });
    setOtpStep('request');
    setOtp('');
    setEditForm({ name: s.name, email: s.email, phone: s.phone||'', role: s.role });
    setMsg('');
  };

  const requestOtp = async () => {
    setOtpLoading(true);
    try {
      await client.post('/admin/staff/' + modal.staff.id + '/edit/request-otp');
      setOtpStep('confirm');
      setMsg('OTP sent to your email — check your inbox');
    } catch(e) { setMsg(e.response?.data||'Failed'); } finally { setOtpLoading(false); }
  };

  const confirmEdit = async () => {
    setConfirmLoading(true);
    try {
      await client.put('/admin/staff/' + modal.staff.id, { ...editForm, otp });
      setMsg('Staff updated successfully'); setModal(null); setOtp(''); load();
    } catch(e) { setMsg(e.response?.data||'Failed'); } finally { setConfirmLoading(false); }
  };

  const confirmDelete = async () => {
    setConfirmLoading(true);
    try {
      await client.delete('/admin/staff/' + modal.staff.id, { data: { otp } });
      setMsg('Staff deleted'); setModal(null); setOtp(''); load();
    } catch(e) { setMsg(e.response?.data||'Failed'); } finally { setConfirmLoading(false); }
  };

  return (
    <div>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:24 }}>
        <h1 style={{ color:'#000', fontSize:22, fontWeight:700, margin:0, fontFamily:'Georgia,serif' }}>Staff Management</h1>
        {role==='SUPER_ADMIN' && <button style={btn('#eff4ff','#1a3cff')} onClick={()=>setShowForm(!showForm)}>{showForm?'Cancel':'+ Add Staff'}</button>}
      </div>

      {msg && <div style={{ background:'#f0fff6', border:'1px solid #b2dfdb', borderRadius:8, padding:'10px 16px', color:'#0a8a40', fontSize:13, marginBottom:16 }}>{msg} <button onClick={()=>setMsg('')} style={{ background:'none', border:'none', color:'#0a8a40', cursor:'pointer' }}>✕</button></div>}

      {showForm && (
        <div style={{ background:'#fff', borderRadius:12, padding:24, border:'1px solid #eee', marginBottom:24 }}>
          <h3 style={{ color:'#000', margin:'0 0 16px', fontSize:16 }}>New Staff Member</h3>
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12 }}>
            <div><label style={{ color:'#555', fontSize:12, display:'block', marginBottom:4 }}>Full Name *</label><input style={inp()} placeholder="John Smith" value={form.name} onChange={e=>setForm({...form,name:e.target.value})} /></div>
            <div><label style={{ color:'#555', fontSize:12, display:'block', marginBottom:4 }}>Email *</label><input style={inp()} placeholder="john@ouresign.com" value={form.email} onChange={e=>setForm({...form,email:e.target.value})} /></div>
            <div><label style={{ color:'#555', fontSize:12, display:'block', marginBottom:4 }}>Phone</label><input style={inp()} placeholder="+1 555-000-0000" value={form.phone} onChange={e=>setForm({...form,phone:e.target.value})} /></div>
            <div><label style={{ color:'#555', fontSize:12, display:'block', marginBottom:4 }}>Role *</label><select style={inp()} value={form.role} onChange={e=>setForm({...form,role:e.target.value})}>{ROLES.map(r=><option key={r} value={r}>{r.replace(/_/g,' ')}</option>)}</select></div>
          </div>
          <button style={btn('#eff4ff','#1a3cff')} onClick={create}>Create Staff Member</button>
        </div>
      )}

      <div style={{ background:'#fff', borderRadius:12, border:'1px solid #eee', overflow:'hidden' }}>
        <table style={{ width:'100%', borderCollapse:'collapse' }}>
          <thead><tr style={{ borderBottom:'1px solid #eee' }}>{['Name','Email','Role','Status','Last Login','Actions'].map(h=><th key={h} style={{ color:'#555', fontSize:11, fontWeight:500, textAlign:'left', padding:'14px 16px', textTransform:'uppercase' }}>{h}</th>)}</tr></thead>
          <tbody>
            {loading ? <tr><td colSpan={6} style={{ color:'#555', padding:24, textAlign:'center' }}>Loading...</td></tr>
            : staff.map(s => (
              <tr key={s.id} style={{ borderBottom:'1px solid #f5f5f5' }}>
                <td style={{ padding:'12px 16px', color:'#000', fontSize:14, fontWeight:500 }}>{s.name}</td>
                <td style={{ padding:'12px 16px', color:'#333', fontSize:14 }}>{s.email}</td>
                <td style={{ padding:'12px 16px' }}><span style={{ background:(rc[s.role]||'#4a6580')+'22', color:rc[s.role]||'#4a6580', padding:'3px 8px', borderRadius:4, fontSize:12, fontWeight:700 }}>{(s.role||'').replace(/_/g,' ')}</span></td>
                <td style={{ padding:'12px 16px' }}><span style={{ background:s.isActive?'#0f2a1a':'#2a1515', color:s.isActive?'#4caf7d':'#e05c5c', padding:'3px 8px', borderRadius:4, fontSize:12 }}>{s.isActive?'ACTIVE':'INACTIVE'}</span></td>
                <td style={{ padding:'12px 16px', color:'#555', fontSize:13 }}>{s.lastLoginAt?new Date(s.lastLoginAt).toLocaleDateString():'Never'}</td>
                <td style={{ padding:'12px 16px' }}>
                  {role==='SUPER_ADMIN' && s.role !== 'SUPER_ADMIN' && (
                    <div style={{ display:'flex', gap:6 }}>
                      <button style={btn('#eff4ff','#1a3cff')} onClick={()=>openModal('edit', s)}>Edit</button>
                      {s.isActive
                        ? <button style={btn('#fff8ec','#b45309')} onClick={async(e)=>{ e.target.disabled=true; e.target.textContent='...'; await client.post('/admin/staff/'+s.id+'/deactivate'); load(); }}>Deactivate</button>
                        : <button style={btn('#f0fff6','#0a8a40')} onClick={async(e)=>{ e.target.disabled=true; e.target.textContent='...'; await client.post('/admin/staff/'+s.id+'/reactivate'); load(); }}>Reactivate</button>
                      }
                      <button style={btn('#fff5f5','#c0392b')} onClick={()=>openModal('delete', s)}>Delete</button>
                    </div>
                  )}
                  {role==='SUPER_ADMIN' && s.role === 'SUPER_ADMIN' && (
                    <span style={{ color:'#555', fontSize:12 }}>Organization Owner</span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {modal && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.75)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:1000 }}>
          <div style={{ background:'#fff', borderRadius:12, padding:32, width:420, border:'1px solid #eee' }}>
            <h3 style={{ color:'#000', margin:'0 0 6px', fontFamily:'Georgia,serif' }}>
              {modal.type==='edit' ? '✏️ Edit Staff Member' : '🗑️ Delete Staff Member'}
            </h3>
            <div style={{ color:'#555', fontSize:13, marginBottom:20 }}>
              {modal.type==='delete' ? `Permanently delete ${modal.staff.name}? This cannot be undone.` : `Editing: ${modal.staff.name}`}
            </div>

            {otpStep === 'request' && (
              <>
                <div style={{ background:'#f9f9f9', border:'1px solid #ddd', borderRadius:8, padding:'14px 16px', marginBottom:20, color:'#333', fontSize:13 }}>
                  For security, an OTP will be sent to your email to confirm this action.
                </div>
                <div style={{ display:'flex', gap:10 }}>
                  <button style={{ flex:1, padding:'10px', background:'#1a5cff', color:'#000', border:'none', borderRadius:6, cursor:otpLoading?'not-allowed':'pointer', fontWeight:600, opacity:otpLoading?0.7:1 }}
                    onClick={requestOtp} disabled={otpLoading}>
                    {otpLoading ? '⏳ Sending...' : 'Send OTP to My Email'}
                  </button>
                  <button style={{ flex:1, padding:'10px', background:'#f0f0f0', color:'#333', border:'none', borderRadius:6, cursor:'pointer' }}
                    onClick={()=>{ setModal(null); setMsg(''); }}>Cancel</button>
                </div>
              </>
            )}

            {otpStep === 'confirm' && (
              <>
                {modal.type==='edit' && (
                  <div style={{ marginBottom:16 }}>
                    <label style={{ color:'#555', fontSize:11, display:'block', marginBottom:4 }}>Full Name</label>
                    <input style={inp()} value={editForm.name||''} onChange={e=>setEditForm({...editForm,name:e.target.value})} />
                    <label style={{ color:'#555', fontSize:11, display:'block', marginBottom:4 }}>Email</label>
                    <input style={inp()} value={editForm.email||''} onChange={e=>setEditForm({...editForm,email:e.target.value})} />
                    <label style={{ color:'#555', fontSize:11, display:'block', marginBottom:4 }}>Phone</label>
                    <input style={inp()} value={editForm.phone||''} onChange={e=>setEditForm({...editForm,phone:e.target.value})} />
                    <label style={{ color:'#555', fontSize:11, display:'block', marginBottom:4 }}>Role</label>
                    <select style={inp()} value={editForm.role||''} onChange={e=>setEditForm({...editForm,role:e.target.value})}>
                      {ROLES.map(r=><option key={r} value={r}>{r.replace(/_/g,' ')}</option>)}
                    </select>
                  </div>
                )}
                <div style={{ background:'#f0fff6', border:'1px solid #b2dfdb', borderRadius:8, padding:'10px 14px', color:'#0a8a40', fontSize:13, marginBottom:14 }}>
                  ✓ OTP sent to your email
                </div>
                <label style={{ color:'#555', fontSize:11, display:'block', marginBottom:6 }}>Enter OTP to confirm</label>
                <input style={inp({ marginBottom:20 })} placeholder="6-digit OTP" value={otp} onChange={e=>setOtp(e.target.value)} maxLength={6} autoFocus />
                <div style={{ display:'flex', gap:10 }}>
                  <button style={{ flex:1, padding:'10px', background:modal.type==='delete'?'#e05c5c':'#1a5cff', color:'#000', border:'none', borderRadius:6, cursor:'pointer', fontWeight:600 }}
                    onClick={modal.type==='edit' ? confirmEdit : confirmDelete} disabled={confirmLoading}>
                    {confirmLoading ? '⏳ Processing...' : modal.type==='edit' ? 'Save Changes' : 'Delete Permanently'}
                  </button>
                  <button style={{ flex:1, padding:'10px', background:'#f0f0f0', color:'#333', border:'none', borderRadius:6, cursor:'pointer' }}
                    onClick={()=>{ setModal(null); setOtp(''); setMsg(''); }}>Cancel</button>
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
